import React, { useContext } from 'react';
import c from 'classnames';
import { CommentEditorContext } from '../../../CommentEditor/context';
import EditorDropzone from '@wix/da-editor-tiptap/pkg/components/lego/EditorDropzone';

import s from './CommentBoxContentWrapper.scss';

export interface Props {
  className?: string;
}

/**
 * Standard styling for the content of our comment box.
 * Also adds the global editor class we need for themeing inside of DaEditor
 */
const CommentBoxContentWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  const { isExpanded } = useContext(CommentEditorContext);
  return (
    <div
      className={c(
        s['commentbox-content'],
        'da-editor-comment',
        isExpanded && s['expanded'],
        className
      )}
    >
      <EditorDropzone>{children}</EditorDropzone>
    </div>
  );
};
CommentBoxContentWrapper.displayName = 'CommentBoxContentWrapper';

export default CommentBoxContentWrapper;
